import React from 'react';
import { SubManager } from '../../classes/SubManager';
import { tracking } from '../../services/TrackingService';
import { AsperaError } from '../../classes/AsperaError';
/**
 * React Component
 *
 * The AsperaCustomTheming renders custom theming CSS if set in Tracking Service
 *
 * @example
 * ```javascript
 * <AsperaCustomTheming />
 * ```
 */
export class AsperaCustomTheming extends React.Component {
    constructor() {
        super(...arguments);
        this.subManager = new SubManager();
    }
    isSafeToInject(item) {
        return (typeof item === 'string' &&
            !item.includes('<') &&
            !item.includes('>') &&
            !item.includes('`') &&
            !item.includes(';') &&
            !item.includes(':') &&
            !item.includes('&'));
    }
    get customCss() {
        const customThemeItems = tracking.currentCustomTheme;
        if (customThemeItems) {
            const customTheme = tracking.currentTheme === 'g10' ? customThemeItems.g10 : customThemeItems.g100;
            if (customTheme) {
                const cssItems = [];
                const parent = 'body .aspera-app-wrapper';
                if (this.isSafeToInject(customTheme.typographyFontFamily)) {
                    cssItems.push(`body, div, html { font-family: ${customTheme.typographyFontFamily} !important; }`);
                }
                if (this.isSafeToInject(customTheme.headerBackground)) {
                    cssItems.push(`${parent} .cds--header { background-color: ${customTheme.headerBackground} !important; }`);
                    cssItems.push(`.title-bar-container { background-color: ${customTheme.headerBackground} !important; }`);
                }
                if (this.isSafeToInject(customTheme.headerTextIcon)) {
                    cssItems.push(`${parent} .cds--header .cds--header__name, ${parent} .cds--header .app-name, ${parent} .cds--header .cds--header__nav { color: ${customTheme.headerTextIcon} !important; }`);
                    cssItems.push(`${parent} .cds--header .cds--header__action svg { color: ${customTheme.headerTextIcon} !important; fill: ${customTheme.headerTextIcon} !important; }`);
                    cssItems.push(`.title-bar-container { color: ${customTheme.headerTextIcon} !important; }`);
                }
                if (this.isSafeToInject(customTheme.headerActiveItemBackground)) {
                    cssItems.push(`${parent} .cds--header .cds--header__action--active { background-color: ${customTheme.headerActiveItemBackground} !important; }`);
                }
                if (this.isSafeToInject(customTheme.headerActiveItemColor)) {
                    cssItems.push(`${parent} .cds--header .cds--header__action--active svg { color: ${customTheme.headerActiveItemColor} !important; fill: ${customTheme.headerActiveItemColor} !important; }`);
                }
                if (this.isSafeToInject(customTheme.headerAccentBorders)) {
                    cssItems.push(`${parent} .cds--header .cds--header__nav::before { background-color: ${customTheme.headerAccentBorders} !important; }`);
                    cssItems.push(`${parent} .cds--header { border-bottom-color: ${customTheme.headerAccentBorders} !important; }`);
                    cssItems.push(`${parent} .cds--header .cds--header__action--active { border-right-color: ${customTheme.headerAccentBorders} !important; border-left-color: ${customTheme.headerAccentBorders} !important; }`);
                }
                if (this.isSafeToInject(customTheme.headerHoverItemBackground)) {
                    cssItems.push(`${parent} .cds--header .cds--header__action:hover { background-color: ${customTheme.headerHoverItemBackground} !important; }`);
                }
                if (this.isSafeToInject(customTheme.leftNavBackground)) {
                    cssItems.push(`${parent} .cds--side-nav { background-color: ${customTheme.leftNavBackground} !important; }`);
                    cssItems.push(`${parent} .cds--side-nav { background-color: ${customTheme.leftNavBackground} !important; }`);
                }
                if (this.isSafeToInject(customTheme.leftNavTextColor)) {
                    cssItems.push(`${parent} .cds--side-nav .cds--side-nav__link, ${parent} .cds--side-nav .cds--side-nav__link span, ${parent} .cds--side-nav .cds--side-nav__submenu, ${parent} .cds--side-nav .cds--side-nav__submenu span { color: ${customTheme.leftNavTextColor} !important;  }`);
                    cssItems.push(`${parent} .cds--side-nav .cds--side-nav__icon > svg { fill: ${customTheme.leftNavTextColor} !important;  }`);
                    cssItems.push(`${parent} .aspera-left-nav.aspera-desktop-left-nav .cds--btn { color: ${customTheme.leftNavTextColor} !important;  }`);
                    cssItems.push(`${parent} .aspera-left-nav.aspera-desktop-left-nav .cds--btn svg { fill: ${customTheme.leftNavTextColor} !important;  }`);
                }
                if (this.isSafeToInject(customTheme.leftNavActiveItemBackground)) {
                    cssItems.push(`${parent} .cds--side-nav .cds--side-nav__link--current { background-color: ${customTheme.leftNavActiveItemBackground} !important; }`);
                    cssItems.push(`${parent} .aspera-left-nav.aspera-desktop-left-nav .desktop-left-nav-item.active-left-nav { background-color: ${customTheme.leftNavActiveItemBackground} !important; }`);
                }
                if (this.isSafeToInject(customTheme.leftNavActiveItemAccent)) {
                    cssItems.push(`${parent} .cds--side-nav .cds--side-nav__link--current::before { background-color: ${customTheme.leftNavActiveItemAccent} !important; }`);
                }
                if (this.isSafeToInject(customTheme.leftNavActiveItemHover)) {
                    cssItems.push(`${parent} .cds--side-nav .cds--side-nav__link:hover, ${parent} .cds--side-nav .cds--side-nav__submenu:hover { background-color: ${customTheme.leftNavActiveItemHover} !important; }`);
                    cssItems.push(`${parent} .aspera-left-nav.aspera-desktop-left-nav .desktop-left-nav-item:hover { background-color: ${customTheme.leftNavActiveItemHover} !important; }`);
                }
                if (this.isSafeToInject(customTheme.loginPanelBackgroundColor)) {
                    cssItems.push(`.aspera-login-page .login-panel-wrapper { background-color: ${customTheme.loginPanelBackgroundColor} !important; }`);
                }
                if (this.isSafeToInject(customTheme.loginPanelTextColor)) {
                    cssItems.push(`.aspera-login-page .login-panel-wrapper { color: ${customTheme.loginPanelTextColor}; }`);
                }
                if (this.isSafeToInject(customTheme.loginInPanelAnnouncementBackgroundColor)) {
                    cssItems.push(`.aspera-login-page .login-panel-announcement { background-color: ${customTheme.loginInPanelAnnouncementBackgroundColor} !important; }`);
                }
                if (this.isSafeToInject(customTheme.loginInPanelAnnouncementTextColor)) {
                    cssItems.push(`.aspera-login-page .login-panel-announcement { color: ${customTheme.loginInPanelAnnouncementTextColor} !important; }`);
                }
                if (this.isSafeToInject(customTheme.loginAnnouncementBackgroundColor)) {
                    cssItems.push(`.aspera-login-page .login-announcement { background-color: ${customTheme.loginAnnouncementBackgroundColor} !important; }`);
                }
                if (this.isSafeToInject(customTheme.loginAnnouncementBackgroundTextColor)) {
                    cssItems.push(`.aspera-login-page .login-announcement { color: ${customTheme.loginAnnouncementBackgroundTextColor} !important; }`);
                }
                if (this.isSafeToInject(customTheme.buttonPrimaryText)) {
                    cssItems.push(`${parent} .cds--btn.cds--btn--primary { color: ${customTheme.buttonPrimaryText} !important; }`);
                    cssItems.push(`${parent} .cds--btn.cds--btn--primary svg { fill: ${customTheme.buttonPrimaryText} !important; }`);
                }
                if (this.isSafeToInject(customTheme.buttonSecondaryText)) {
                    cssItems.push(`${parent} .cds--btn.cds--btn--secondary { color: ${customTheme.buttonSecondaryText} !important; }`);
                    cssItems.push(`${parent} .cds--btn.cds--btn--secondary svg { fill: ${customTheme.buttonSecondaryText} !important; }`);
                }
                if (this.isSafeToInject(customTheme.buttonTertiaryText)) {
                    cssItems.push(`${parent} .cds--btn.cds--btn--tertiary { color: ${customTheme.buttonTertiaryText} !important; }`);
                    cssItems.push(`${parent} .cds--btn.cds--btn--tertiary svg { fill: ${customTheme.buttonTertiaryText} !important; }`);
                }
                if (this.isSafeToInject(customTheme.buttonTertiaryTextHoverActive)) {
                    cssItems.push(`${parent} .cds--btn.cds--btn--tertiary:hover { color: ${customTheme.buttonTertiaryTextHoverActive} !important; }`);
                    cssItems.push(`${parent} .cds--btn.cds--btn--tertiary:hover svg { fill: ${customTheme.buttonTertiaryTextHoverActive} !important; }`);
                    cssItems.push(`${parent} .cds--btn.cds--btn--tertiary:active { color: ${customTheme.buttonTertiaryTextHoverActive} !important; }`);
                    cssItems.push(`${parent} .cds--btn.cds--btn--tertiary:active svg { fill: ${customTheme.buttonTertiaryTextHoverActive} !important; }`);
                }
                return cssItems.join('\n');
            }
        }
        return '';
    }
    getCustomThemeCss(customThemeItems, parent) {
        const keys = Object.keys(customThemeItems).filter(key => key.includes('$'));
        const cssItems = [];
        keys.forEach(key => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const value = customThemeItems[key];
            if (this.isSafeToInject(value)) {
                cssItems.push(`--cds-${key.replace('$', '')}: ${value};`);
            }
        });
        return `${parent} {\n${cssItems.join('\n')}}`;
    }
    get customThemeCssDark() {
        const customTheme = tracking.currentCustomTheme;
        if (customTheme) {
            const customThemeItems = customTheme.g100;
            if (customThemeItems) {
                return this.getCustomThemeCss(customThemeItems, 'body.cds--g100, .cds--g100');
            }
        }
        return '';
    }
    get customThemeCssLight() {
        const customTheme = tracking.currentCustomTheme;
        if (customTheme) {
            const customThemeItems = customTheme.g10;
            if (customThemeItems) {
                return this.getCustomThemeCss(customThemeItems, 'body.cds--g10, .cds--g10');
            }
        }
        return '';
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    componentDidMount() {
        this.subManager.setSubscription(tracking.customThemeChanges.subscribe({
            next: () => {
                this.setState({});
            },
            error: error => {
                new AsperaError('AsperaCustomTheming: unable to subscribe to theme changes', error);
            },
        }));
    }
    render() {
        const { className } = this.props;
        return (React.createElement("div", { className: `aspera-custom-theming ${className ? className : ''}` },
            React.createElement("style", null,
                this.customCss,
                this.customThemeCssLight,
                this.customThemeCssDark)));
    }
}
